import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { ApiResponse } from '@cast/shared-types';

const apiFn = apiClient.user.setFingerprint;

type SetFingerprintResponse = ApiResponse<typeof apiFn>;

export const useSetFingerprintMutation = (): UseMutationResult<
  SetFingerprintResponse,
  unknown,
  string,
  unknown
> => {
  return useMutation({
    mutationFn: (eventId: string) =>
      apiFn({
        setFingerprintRequest: { eventId },
      }),
  });
};
